const $ = require('jquery');
import run from '../../utilities/run';
const _ = require("underscore");
import {isPresent, rgxTest} from "../../utilities/general";
import render from "../../utilities/render";
import {handleDisplayFor, resetDisplay, hide, setOptionsForSelect} from "../../utilities/selectorHelpers";
import {bindFileInputChangeValidation} from "../../utilities/jqueryValidationMethods";
import {quickFileUploader} from "../../components/QuickFileUploader/QuickFileUploader";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import {SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT} from "../../constants";

// Live form from jsp
run("#update-order-packaging", () => {
  const el = $("#update-order-packaging");
  attachFunctionality(el);
  setupEditChecker();
});

function setupEditChecker(){
  EditChecker.bindNavigation();
  EditChecker.bindChangeListener("#update-order-packaging");
  EditChecker.bindCancelButton(".order-packaging-cancel");
}

function attachFunctionality(el) {

	const submitModalFlow = new SubmitModalFlow();
	submitModalFlow.init();


  /*
   * START: Packing Materials Section
   *
   *
   */
  const BG_CLASS_MAP = {
    white: "q-tw-white",
    grey: "q-tw-lightest-grey"
  };

  console.log('update-order-packaging is running...');
  const updateOrderPackagingForm = el;
  const logoUploaderEl = el.find(".logo-uploader");
  const togglers = el.find(".b2b-b2c-togglers");
  const docDetailForm = el.find(".document-detail-form");
  const docMessage = el.find(".document-message");
  const addressSelect = $("#companyAddressLocation");
  let addressList = addressSelect.data('options');
  const orderPackage = el.data("order-package");
  const saveURL = el.data("save-url");
  const detailPageURL = el.data("detail-url");

  const packingTogglers = el.find(".packing-toggler");
  const vasBoxArr = el.data("vas-box");
  const vasTsArr = el.data("vas-ts");
  const vasGiftWrapColorArr = el.data("vas-gift-wrap-color");
  const vasGiftOptionsArr = el.data("vas-gift-options");
  const vasRtlImage = el.data("rtl-brand-logo");

  const rtllogoFileNameId = el.find("#rtlBrandLogoFile");
  const rtllogoImageId = el.find("#rtllogoImage");
  const rtlLogoFileNameTextInput = el.find(".qfu-file-text-input");

  const boxTypeSelect = $("#boxTypeId");
  let boxTypeSelectList = boxTypeSelect.data('options');

  const tsPaperSelect = $("#tissuePaperId");
  let tsPaperSelectList = tsPaperSelect.data('options');

  const giftOptionsSelect = $("#giftOptionsId");
  let giftOptionsSelectList = giftOptionsSelect.data('options');

  const giftBagWrappingColorSelect = $("#giftBagWrappingColorId");
  let giftBagWrappingColorSelectList = giftBagWrappingColorSelect.data('options');

  const brandLogoOnBoxSelect = $("#brandLogoOnBoxId");
  let brandLogoOnBoxSelectList = brandLogoOnBoxSelect.data('options');




  rtllogoFileNameId.val(orderPackage.rtlBrandLogoFile || "");
  rtllogoImageId.val(orderPackage.rtlBrandLogoIamge || "");
  // set text input value here, and the quickFileUploader
  // component will recognize this, and render with remove btn,
  // even though a file has not been selected via edit on this page
  rtlLogoFileNameTextInput.val(orderPackage.rtlBrandLogoFile || "");


  quickFileUploader(logoUploaderEl);

  const validator = el.validate({
    errorPlacement: function(error, element) {
      let appendClosest = $(element).data('error-placement-append-closest');
      if (appendClosest) {
        $(element).closest(appendClosest).append(error);
      } else {
        error.insertAfter(element);
      }
    },
    rules: {
      logoImg: {
        maxFileSizeBytes: 200000000,
        permittedFileTypes: ["image/png", "image/jpeg"],
        required: function(element){
          return !isPresent(rtlLogoFileNameTextInput.val());
        }
      },

    }
  });


  // This is a helper function that can be reused
  // specifically for packing material related selects
  function setGenericDataInOptionForPackingSelect({option, data}){
    option.data('note', data.opcCost);
    if(rgxTest(/Default/i, data.opcValue)){
      option.data('bg-well-color', "white");
    }
    else{
      option.data('bg-well-color', "grey");
    }
    return {option, data};
  }


  setOptionsForSelect({
    selectElement: boxTypeSelect,
    list: boxTypeSelectList,
    valueDataKey: "opcValue",
    textDataKey: "opcValue",
    afterOptionCreate: setGenericDataInOptionForPackingSelect,
    initialSelectValue: ()=>{
      return orderPackage.rtlBoxType || /default/i;
    }
  });


  setOptionsForSelect({
    selectElement: brandLogoOnBoxSelect,
    list: brandLogoOnBoxSelectList,
    valueDataKey: "opcValue",
    textDataKey: "opcValue",
    afterOptionCreate: _.compose(setGenericDataInOptionForPackingSelect, setDataForBrandLogoOnBoxSelect),
    initialSelectValue: ()=>{
      return orderPackage.rtlBrandLogoColor || /default/i;
    }
  });

  function setDataForBrandLogoOnBoxSelect({option, data}){
    if(!rgxTest(/Default/i, data.opcValue)){
      option.data('quick-toggler-target', ".packing-logo-upload-area");
    }
    return {option, data};
  }



  setOptionsForSelect({
    selectElement: tsPaperSelect,
    list: tsPaperSelectList,
    valueDataKey: "opcValue",
    textDataKey: "opcValue",
    afterOptionCreate: setGenericDataInOptionForPackingSelect,
    initialSelectValue: ()=>{
      return orderPackage.rtlTsPaper || /default/i;
    }
  });

  setOptionsForSelect({
    selectElement: giftOptionsSelect,
    list: giftOptionsSelectList,
    valueDataKey: "opcValue",
    textDataKey: "opcValue",
    afterOptionCreate: setGenericDataInOptionForPackingSelect,
    initialSelectValue: ()=>{
      return orderPackage.rtlGo || /default/i;
    }
  });


  setOptionsForSelect({
    selectElement: giftBagWrappingColorSelect,
    list: giftBagWrappingColorSelectList,
    valueDataKey: "opcValue",
    textDataKey: "opcValue",
    afterOptionCreate: setGenericDataInOptionForPackingSelect,
    initialSelectValue: ()=>{
      return orderPackage.rtlGoColor || /default/i;
    }
  });



  packingTogglers.each(function() {
    const toggler = $(this);
    handleWellBgForToggler(toggler);
    handleNoteForToggler(toggler);
  });

  packingTogglers.on("change", function(e) {
    const toggler = $(this);
    handleWellBgForToggler(toggler);
    handleNoteForToggler(toggler);
  });



  function handleNoteForToggler(toggler) {
    const noteText = toggler.find("option:selected").data("note");
    const noteEl = toggler.closest(".packing-row").find(".packing-toggler-note-target");
    noteEl.text(noteText);
  }

  function handleWellBgForToggler(toggler) {
    const bgEl = toggler.closest(".packing-well");
    const bgClassKey = toggler.find("option:selected").data("bg-well-color");
    removeClassesViaKeys(bgEl, BG_CLASS_MAP);
    bgEl.addClass(BG_CLASS_MAP[bgClassKey]);
  }

  function removeClassesViaKeys(el, dict) {
    let classStr = "";
    _(dict).mapObject((cls, k) => {
      classStr += cls + " ";
    });
    el.removeClass(classStr);
  }

  function setDivColor(selectId) {
    const option = $(`#${selectId} option:contains(Default)`);
    console.log("option " + option);
    const val = option.val()
    $("'#" + selectId + "'").val(val)
    $("'#" + selectId + "'").trigger('change.select2');
  }

  bindFileInputChangeValidation();

  /*
   * END
   */



  /*
   * START: Order Documents Section
   *
   *
   */


  toggleBottomForm();

  togglers.on("change", function(e) {
    e.preventDefault();
    toggleBottomForm();
  });

  $(addressList).each(function() {
    const option = $('<option />');
    option.attr('value', this.cadId).text(this.cadLocationName);
    addressSelect.append(option);
  });

  function toggleBottomForm() {
    const anyAreON = _(togglers.toArray()).any((item) => {
      return $(item).is(":checked");
    });

    docDetailForm.hide();
    docMessage.hide();

    if (anyAreON) {
      docDetailForm.show();
      docMessage.hide();
    } else {
      docDetailForm.hide();
      docMessage.show();
    }
  }

  setData();

  function setData() {
    addressSelect.val(orderPackage.address);
    fillTheAddressSection(orderPackage.address);
    if (orderPackage.packingslipb2c == "Y") {
      $("#packing-slip-b2c").prop('checked', true);
    }

    if (orderPackage.packingslipb2b == "Y") {
      $("#packing-slip-b2b").prop('checked', true);
    }

    if (orderPackage.commercialinvoiceb2b == "Y") {
      $("#commercial-invoice-b2b").prop('checked', true);
    }

    toggleBottomForm();

    $("#ps-b2c-opcId").val(orderPackage.psb2copcId);
    $("#ps-b2b-opcId").val(orderPackage.psb2bopcId);
    $("#ci-b2b-opcId").val(orderPackage.cib2bopcId);
    $("#address-opcId").val(orderPackage.addressopcId);
    $("#cn-opcId").val(orderPackage.cnopcId);
    $("#em-opcId").val(orderPackage.emopcId);
    $("#ph-opcId").val(orderPackage.phopcId);
    $("#cnh-opcId").val(orderPackage.cnhopcId);
    $("#cnb-opcId").val(orderPackage.cnbopcId);
    $("#companyName").val(orderPackage.companyName);
    $("#contactEmail").val(orderPackage.contactEmail);
    $("#phoneNumber").val(orderPackage.phoneNumber);
    $("#customNoteHeader").val(orderPackage.customNoteHeader);
    $("#customNoteBody").val(orderPackage.customNoteBody);
    $("#rtlGiftMsgId").html(orderPackage.rtlGm);
    $("#rtlGiftMsgCostId").html(orderPackage.rtlGmCost);
  }

  $(addressSelect).change(onAddressSelectChange);

  let prevLocSelVal = $(addressSelect);

  function onAddressSelectChange(e) {
    e.preventDefault();
    const val = $(this).val();
    if (prevLocSelVal != val) {
      fillTheAddressSection(val);
    }
    prevLocSelVal = val;
  }

  function fillTheAddressSection(val) {
    const selectedAddress = addressList.filter(function(obj) {
      return obj.cadId == val;
    })[0];
    if (isPresent(selectedAddress)) {
      $("#order-package-address1").html(selectedAddress.cadAddress1);
      $("#order-package-address2").html(selectedAddress.cadAddress2);
      $("#city-state-zip").html(selectedAddress.cadCity + ',' + selectedAddress.cadState + ',' + selectedAddress.cadZipcode);
    }
  }

  /*Removed for EditChecker above
  $(".order-packaging-cancel").on("click", function(e) {
    e.preventDefault();
    $("#order-packaging-cancel-modal").modal("show");
  });
  */

  $(".removeBrandLogo").on("click", function(e) {
    e.preventDefault();
    rtllogoFileNameId.val("");
    rtllogoImageId.val("");
    rtlLogoFileNameTextInput.val("");
  });

  $(".order-packaging-save").on("click", function(e) {
    e.preventDefault();
    if(!updateOrderPackagingForm.valid()){
      return;
    }
    // console.log($('#update-order-packaging').serialize());
    save({
      url: saveURL,
      success: saveSuccess,
      error: saveError
    });
  });

  /*function save({url, success, error}) {
    $.ajax({
      enctype: 'multipart/form-data',
      processData: false,
      data:  $('#update-order-packaging').serialize(),
      url: url,
      dataType:"JSON",
      type: 'POST',
      success: success,
      error: error
    });
  }*/

  function save({url, success, error}) {
    submitModalFlow.showLoadingModal();
    $.ajax({
      data: new FormData($('#update-order-packaging').get(0)),
      url: url,
      processData: false,
      contentType: false,
      dataType: "JSON",
      type: 'POST',
      success: success,
      error: error
    });
  }

  function saveSuccess(data) {
    if (data.respose == "success") {
      EditChecker.setPageClean();
	    submitModalFlow.showSuccessModal();
	    setTimeout(function() {	
		    location.href = `${detailPageURL}`;
      }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
    } else {
      submitModalFlow.showFailureModal();
    }
  }

  function saveError() {
    submitModalFlow.showFailureModal();
  }
  /*
   * END
   */
}



// WEBPACK FOOTER //
// ./src/pages/orderpackaging/orderPackaging.js